export default class CreateShortCoursesCtrl {

  constructor ($scope, $timeout, $mdDialog, $stateParams, WorkPlanSrv, WorkPlanModalSrv, $cookies, GlobalConfig, GlobalSrv) {
    var createShortCourseVm = this
    const currentUser = JSON.parse($cookies.get('currentUser'))
    const texts = GlobalConfig.appTexts
    let post = {
      workplanId: currentUser.workplanId,
      teacherId: currentUser.teacherId,
      name: currentUser.name
    }
    createShortCourseVm.sourceType = []
    createShortCourseVm.scholarshipProgramType = []
    createShortCourseVm.isEditing = ($stateParams.workplanTeacherActivityId) ? true : false
    createShortCourseVm.rangeType = GlobalConfig.periods.rangeType
    createShortCourseVm.createOrEdit = 'Crear'
    createShortCourseVm.textCreateOrEdit = texts.saved
    createShortCourseVm.createOrEditMV = texts.createDialog
    createShortCourseVm.typePeriod = []
    createShortCourseVm.periodsArray = []
    createShortCourseVm.selectedTypePeriod = {}
    createShortCourseVm.isTouchedPeriods = false
    createShortCourseVm.startDate = null
    createShortCourseVm.endDate = null
    createShortCourseVm.minStartDate = moment().toDate()
    createShortCourseVm.minEndDate = new Date()
    createShortCourseVm.isSaveButtonDisabled = false
    createShortCourseVm.isFeedback = currentUser.isFeedback
    createShortCourseVm.hasError = hasError
    createShortCourseVm.showErrorMessages = showErrorMessages
    createShortCourseVm.validateForm = validateForm
    createShortCourseVm.validateCheklistPeriods = validateCheklistPeriods
    createShortCourseVm.funSelectedPeriod = funSelectedPeriod
    createShortCourseVm.startDateChange = startDateChange
    createShortCourseVm.addShortCourse = addShortCourse
    createShortCourseVm.cleanRangeType = cleanRangeType
    createShortCourseVm.close = close
    createShortCourseVm.dt_start = $cookies.get('wp_start')
    createShortCourseVm.dt_end = $cookies.get('wp_end')

    createShortCourseVm.updateRangeType = (val) => {
      createShortCourseVm.rangeType = val
      createShortCourseVm.periodsArray = []
      createShortCourseVm.startDate = null
      createShortCourseVm.endDate = null
    }
    createShortCourseVm.updateRangeData = (val) => {
      createShortCourseVm.periodsArray = val['periods']
      createShortCourseVm.startDate = val['dates'][0]
      createShortCourseVm.endDate = val['dates'][1]
    }

    activate()

    function activate () {
      if (createShortCourseVm.isEditing) {
        createShortCourseVm.workplanTeacherActivityId = $stateParams.workplanTeacherActivityId
        createShortCourseVm.createOrEdit = 'Editar'
        createShortCourseVm.createOrEditMV = texts.editDialog
        createShortCourseVm.textCreateOrEdit = texts.modified
        getDataShortCourses()
      }

      WorkPlanSrv.getDataFormShortCourses.getList(post).$promise.then(
        dataReturn => {
          if (dataReturn.status) {
            loadData(dataReturn)
          } else {
            console.log('Comunications problem')
          }
        },
        data => {
          console.log(data)
        }
      )
    }

    function loadData (data) {
      createShortCourseVm.typePeriod = data.listPeriods
      createShortCourseVm.listsTypeCourse = data.listTypeCourse.items
      createShortCourseVm.listModalities = data.listModalityCourse.items
      createShortCourseVm.listRoles = data.listRoleCourse.items
    }

    function hasError (input) {
      if (input.$invalid && (input.$dirty || input.$touched)) {
        return 'has-error'
      }
    }

    function showErrorMessages (input) {
      return input.$dirty || input.$touched
    }

    function addShortCourse (isExecution) {
      let origin = GlobalConfig.activityTypeId.originActivityPlanning
      if (isExecution) {
        origin = GlobalConfig.activityTypeId.originActivityExecution
      }
      createJson(origin)
    }

    function validateForm (form) {
      return form.$invalid ||
             createShortCourseVm.validateCheklistPeriods()
    }

    function createJson (origin) {
      var shortCourse = {
        teacherId: post.teacherId,
        workplanId: post.workplanId,
        name: createShortCourseVm.name,
        description: createShortCourseVm.description,
        hoursPlanning: createShortCourseVm.plannedHours,
        activityId: GlobalConfig.minorActivityId.shortCourse,
        itemTypeCourseId: createShortCourseVm.type,
        itemModalityId: createShortCourseVm.modality,
        itemRoleId: createShortCourseVm.rol,
        timeRangeTypeId: createShortCourseVm.rangeType,
        origin: origin,
        isFeedbackActivity: createShortCourseVm.isFeedback
      }

      if (createShortCourseVm.isEditing) {
        shortCourse.workplanTeacherActivityId = createShortCourseVm.workplanTeacherActivityId
      }

      if (parseInt(createShortCourseVm.rangeType) === GlobalConfig.periods.rangeType) {
        var arrayPeriod = []
        for (var index in createShortCourseVm.periodsArray) {
          var temp = {
            periodId: createShortCourseVm.periodsArray[index]
          }
          arrayPeriod.push(temp)
        }
        shortCourse.periods = arrayPeriod
      } else {
        shortCourse.startDate = new Date(createShortCourseVm.startDate)
        shortCourse.endDate = new Date(createShortCourseVm.endDate)
      }

      addOrEditshortCourse(shortCourse)
    }

    function addOrEditshortCourse (shortCourse) {
      createShortCourseVm.isSaveButtonDisabled = true
      WorkPlanSrv.addShortCourses.save(shortCourse).$promise.then(function (dataReturn) {
        if (dataReturn.status) {
          getSendNotify (shortCourse.origin)
          confirmShortCourseAction()
        } else {
          createShortCourseVm.isSaveButtonDisabled = false
          console.log('Error Comunications')
        }
      }, function (data) {
        createShortCourseVm.isSaveButtonDisabled = false
        console.log(data)
      })
    }

    function validateCheklistPeriods () {
      return (createShortCourseVm.rangeType == 1 ? createShortCourseVm.periodsArray.length < 1 : false)
    }

    function funSelectedPeriod (period, checked) {
      if (checked) {
        if (!createShortCourseVm.periodsArray.includes(period.periodId)) {
          createShortCourseVm.periodsArray.push(period.periodId)
        }
      } else {
        let index = createShortCourseVm.periodsArray.indexOf(period.periodId)
        if (index != -1) {
          createShortCourseVm.periodsArray.splice(index, 1)
        }
      }
      createShortCourseVm.isTouchedPeriods = true
    }

    function startDateChange () {
      let m = moment(createShortCourseVm.startDate)
      createShortCourseVm.minEndDate = m.isValid() ? m/*.add(1, 'days')*/.toDate() : null
    }

    function confirmShortCourseAction () {
      let header = {
        createOrEdit: createShortCourseVm.createOrEditMV,
        textCreateOrEdit: createShortCourseVm.textCreateOrEdit,
        itemName: createShortCourseVm.name,
        nameModal: texts.modalTypeName.shortCourses,
        modalType: texts.modalTypeId.shortCourses
      }
      WorkPlanModalSrv.setVariableSuccessDialog(header)
      WorkPlanModalSrv.successDialog(header).then((promise) => { })
    }

    function getDataShortCourses () {
      let post = {
        workplanTeacherActivityId: parseInt(createShortCourseVm.workplanTeacherActivityId)
      }

      WorkPlanSrv.getShortCoursesById.get(post).$promise.then(function (dataReturn) {
        if (dataReturn.status) {
          setValues(dataReturn.data)
        } else {
          console.log('Comunications problem with the server')
        }
      }, function (data) {

      })
    }

    function setValues (shortCourse) {
      createShortCourseVm.name = shortCourse.name
      createShortCourseVm.description = shortCourse.description
      createShortCourseVm.plannedHours = shortCourse.hoursPlanned
      createShortCourseVm.type = shortCourse.itemTypeCourseId
      createShortCourseVm.modality = shortCourse.itemModalityId
      createShortCourseVm.rol = shortCourse.itemRoleId
      createShortCourseVm.rangeType = shortCourse.timeRangeTypeId
      createShortCourseVm.dt_start = moment(shortCourse.startDate, 'YYYY-MM-DD').toDate()
      createShortCourseVm.dt_end = moment(shortCourse.endDate, 'YYYY-MM-DD').toDate()
      createShortCourseVm.periodsArray = []
      createShortCourseVm.selectedTypePeriod = {}

      if (createShortCourseVm.rangeType == GlobalConfig.periods.rangeType) {
        var splits = shortCourse.periodId.split(',')
        if (splits) {
          for (var i = 0; i < splits.length; i++) {
            var valor = splits[i]
            createShortCourseVm.periodsArray.push(parseInt(valor))
            createShortCourseVm.selectedTypePeriod[valor] = true
          }
        }
      }

      if (shortCourse.startDate) {
        var startDateNew = moment(shortCourse.startDate, 'YYYY-MM-DD').toDate()
        if (startDateNew <= moment().toDate()) {
          createShortCourseVm.minStartDate = moment(shortCourse.startDate, 'YYYY-MM-DD').toDate()
        }
        startDateChange()
      }

      createShortCourseVm.isEditing = true
    }

    function cleanRangeType () {
      if (parseInt(createShortCourseVm.rangeType) == GlobalConfig.periods.rangeType) {
        createShortCourseVm.startDate = null
        createShortCourseVm.endDate = null
      } else {
        createShortCourseVm.periodsArray = []
        createShortCourseVm.selectedTypePeriod = null
      }
    }

    function close () {
      return $mdDialog.hide()
    }

    function getSendNotify (origin) {
      let msg = 'El profesor ' + currentUser.dsFullname + ' ha registrado una nueva actividad en educación continuada en la etapa de planeación.'
      if (origin == GlobalConfig.activityTypeId.originActivityExecution) {
        msg = 'El profesor ' + currentUser.dsFullname + ' ha registrado una nueva actividad en educación continuada en la etapa de ejecución.'
      }
      let data = {
        idTeacher: currentUser.teacherId,
        dsName: 'Notificación, se agregó o editó una actividad en educación continuada',
        dsDescription: msg,
        idNotification_delivery_type: GlobalConfig.notificationType.inbox,
        is_grouped: 1,
        submodule: GlobalConfig.modules.extentionAndVisibility
      }
      GlobalSrv.sendNotificationsEvaluatorsSubmodule(data)
    }
  }// FIN DEL CONSTRUCTOR

  preventInput (event) {
    var vKey = 86
    if (event.keyCode == vKey) {
      event.preventDefault()
    }
    return
  }
}

CreateShortCoursesCtrl.$inject = ['$scope', '$timeout', '$mdDialog', '$stateParams', 'WorkPlanSrv', 'WorkPlanModalSrv', '$cookies', 'GlobalConfig', 'GlobalSrv']



// WEBPACK FOOTER //
// ./src/app/u-faculty/workplan/extensionVisibility/shortCourses/create/createShortCoursesCtrl.js